import { SafetyLink } from '../components/AccountSafety';
import React, { useContext, useState, useEffect } from 'react';
import EditProfilePage from './EditProfilePage';
import GestionMyPage from './GestionMyPage';
import './MyPage.css';
import { UserContext } from '../contexts/UserContext';
import ProtectedRoute from '../components/ProtectedRoute';
import { useNavigate, useSearchParams } from 'react-router-dom';
import floatingMenuStyles from '../styles/FloatingMenuStyles.module.css';
import { useLanguage } from '../utils/language';

// 프로필 애니메이션 컴포넌트
export function ProfileAnimation() {
  // 단순 핑크색 원
  return (
    <div className="profile-image-container">
      <div style={{
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        background: '#ff4d8b',
        border: '2px solid #eee',
        margin: '0 auto'
      }} />
    </div>
  );
}

// 게스트 아티스트용 더미 컴포넌트 (실제 파일로 분리 가능)
function GuestMyPage() {
  const lang = useLanguage();

  const welcomeText = lang === 'ko' ? '게스트 아티스트님, 환영합니다!' :
    lang === 'fr' ? 'Bienvenue, Artiste invité !' :
      'Welcome, Guest Artist!';

  return (
    <div style={{ textAlign: 'center', marginTop: 40, fontSize: 20 }}>
      <ProfileAnimation />
      {welcomeText}
    </div>
  );
}

// 메뉴 텍스트 다국어 지원
const getMenuText = (lang) => ({
  edit: lang === 'ko' ? '정보 수정' : lang === 'fr' ? 'Modifier infos' : 'Edit Info',
  gestion: lang === 'ko' ? '페이지 편집' : lang === 'fr' ? 'Éditer page' : 'Edit Page',
});

const MENU_ITEMS = [
  { key: 'edit', label: 'Edit Info' },
  { key: 'gestion', label: 'Edit Page', only: ['staff_artist', 'admin', 'guest_artist'] },
];

function MyPage() {
  const { userInfo } = useContext(UserContext);
  const level = userInfo?.level;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [hasAnimated, setHasAnimated] = useState(false);

  // 사용자 언어 설정 사용
  const lang = useLanguage();
  const MENU_TEXT = getMenuText(lang);

  // 컴포넌트가 마운트된 후 애니메이션 상태를 true로 설정
  useEffect(() => {
    const timer = setTimeout(() => {
      setHasAnimated(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  // 쿼리에서 tab 읽기, 없으면 기본값
  const getDefaultMenu = () => {
    if (level === 'admin' || level === 'staff_artist') return 'edit';
    if (level === 'guest_artist') return 'guest';
    return 'edit';
  };
  const selectedMenu = searchParams.get('tab') || getDefaultMenu();

  // 메뉴 필터링
  const visibleMenus = MENU_ITEMS.filter(
    item => !item.only || item.only.includes(level)
  );
  // edit 버튼만 맨 오른쪽으로 이동
  const menusExceptEdit = visibleMenus.filter(item => item.key !== 'edit');
  const editMenu = visibleMenus.find(item => item.key === 'edit');
  const orderedMenus = editMenu ? [...menusExceptEdit, editMenu] : menusExceptEdit;

  // 메뉴 클릭 시 navigate
  const handleMenuClick = (key) => {
    navigate(`/mypage?tab=${key}`);
  };

  // 본문 렌더링
  let content = null;
  if (level === 'guest_artist') {
    content = <GuestMyPage />;
  } else if (level === 'admin' || level === 'staff_artist') {
    if (selectedMenu === 'edit') content = <EditProfilePage />;
    else if (selectedMenu === 'gestion') content = (
      <ProtectedRoute allowedLevels={['admin', 'staff_artist', 'guest_artist']}>
        <GestionMyPage />
      </ProtectedRoute>
    );
    else content = <EditProfilePage />;
  } else {
    // client 등
    if (selectedMenu === 'gestion') content = (
      <ProtectedRoute allowedLevels={['admin', 'staff_artist', 'guest_artist']}>
        <GestionMyPage />
      </ProtectedRoute>
    );
    else content = <EditProfilePage />;
  }

  return (
    <div className="my-page-wrapper">
      {/* 섹션1: 상단 고정 스크롤 메뉴 */}
      <div className={`${floatingMenuStyles.myPageMenuWrapper} ${hasAnimated ? floatingMenuStyles.animated : ''}`}>
        <div className={floatingMenuStyles.myPageMenuList}>
          {orderedMenus.map(item => (
            <button
              key={item.key}
              className={`${floatingMenuStyles.floatingMenuBtn}${selectedMenu === item.key ? ' selected' : ''}`}
              onClick={() => handleMenuClick(item.key)}
              style={selectedMenu === item.key ? {
                color: '#000',
                borderColor: '#000'
              } : {
                color: '#666',
                borderColor: '#666'
              }}
            >
              {MENU_TEXT[item.key]}
            </button>
          ))}
        </div>
      </div>
      {/* 상단 여백 */}
      <div className="top-spacer" />
      {/* 섹션2: 본문 */}
      <SafetyLink />
      {content}
      {/* 하단 여백 */}
      <div className="bottom-spacer" />
    </div>
  );
}

export default MyPage; 
